import { ScorecardElementSymbol } from '../../../Scorecard';

export const SCORECARD_GRID_ROWS: ScorecardElementSymbol[][] = [
  ['Er', 'Ir', 'Es'],
  ['Sr', 'Br', 'Dr', 'Tr'],
  ['Lt', 'Qt', 'Rt', 'Bt', 'Tt'],
];

export function getVisibleScorecardGridRows(visibleElements: ScorecardElementSymbol[]) {
  const visibleElementSet = new Set(visibleElements);

  return SCORECARD_GRID_ROWS.map((row) => row.filter((symbol) => visibleElementSet.has(symbol))).filter(
    (row): row is ScorecardElementSymbol[] => row.length > 0
  );
}
